import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Project/vamedi/src/modules/Services/FirstService/First/First.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Project/vamedi/src/modules/Services/FirstService/Five/Five.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Project/vamedi/src/modules/Services/FirstService/Four/Four.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Project/vamedi/src/modules/Services/FirstService/Second/Second.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Project/vamedi/src/modules/Services/FirstService/Six/Six.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/Project/vamedi/src/modules/Services/FirstService/Third/Third.tsx");
